import { Badge } from "@/components/ui/badge";
import { cn } from "@/lib/utils";

interface TagBadgeProps {
  tag: string;
  variant?: "default" | "outline";
  size?: "sm" | "default";
  className?: string;
}

const getTagColor = (tag: string) => {
  switch (tag) {
    case "decision-maker": return "bg-purple-100 text-purple-800 border-purple-200";
    case "key-contact": return "bg-blue-100 text-blue-800 border-blue-200";
    case "budget-holder": return "bg-green-100 text-green-800 border-green-200";
    case "moved-company": return "bg-orange-100 text-orange-800 border-orange-200";
    case "reactivated": return "bg-cyan-100 text-cyan-800 border-cyan-200";
    case "inactive": return "bg-red-100 text-red-800 border-red-200";
    case "follow-up-needed": return "bg-yellow-100 text-yellow-800 border-yellow-200";
    case "responsive": return "bg-emerald-100 text-emerald-800 border-emerald-200";
    default: return "bg-gray-100 text-gray-800 border-gray-200";
  }
};

export function TagBadge({ tag, variant = "outline", size = "sm", className }: TagBadgeProps) {
  const sizeClasses = size === "sm" ? "text-xs px-2 py-0.5" : "";
  
  return (
    <Badge 
      variant={variant}
      className={cn(
        getTagColor(tag),
        sizeClasses,
        className
      )}
    >
      {tag}
    </Badge>
  );
}